// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Form... Remove this comment to see the full error message
import { UserKeys } from 'FormsCommonComponents/lib/User';
import { Set as ImmutableSet } from 'immutable';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Form... Remove this comment to see the full error message
import User from 'FormsCommonComponents/lib/User';
export function getUser(state) {
  return state.user || new User();
}
export function hasScope(state, scopeName) {
  const user = getUser(state);
  const scopes = user.get(UserKeys.SCOPES) || ImmutableSet();
  return Boolean(scopes.contains(scopeName));
}
export function getUserEmail(state) {
  return getUser(state).get(UserKeys.EMAIL);
}
export function getUserId(state) {
  return getUser(state).get(UserKeys.USER_ID);
}
export function getUserLocale(state) {
  return getUser(state).get(UserKeys.LOCALE);
}
export function getLangEnabled(state) {
  return getUser(state).get(UserKeys.LANG_ENABLED);
}